export const fonts = {
  fontFamily: 'Gilroy-Regular',
  fontFamilyExtraBold: 'Gilroy-ExtraBold',
  fontFamilyLight: 'Gilroy-Light',
  fontFamilyPoppinsLight: 'Poppins-Light',
  fontFamilyMallanna: 'Mallanna-Regular',
}
